'use strict';

import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import BookingInfosCard from 'Components/Front/BookingInfosCard';
import Breadcrumb from 'Components/Front/Breadcrumb';
import AddBookingServices from 'Components/Front/Booking/AddBookingServices';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import Loader from 'Pure/Loader';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { formatNum, num, isTrue, getTotalServiceAmount } from 'Shared/utilities';
import { action, URL } from 'Shared/Routes';
const {
  app,
  qwest
} = window;
function getToken() {
  let url = document.location.pathname;
  if (url.endsWith('/') && url !== '/') {
    url = url.slice(0, -1);
  }
  return url.slice(url.lastIndexOf('/') + 1);
}
export default class AddBookingServicesPage extends Component {
  state = {
    loading: true,
    selected: {},
    added_amount: 0,
    status_messages: {},
    breadcrumb: [{
      name: 'home',
      url: URL('HomePage'),
      label: 'Accueil'
    }, {
      name: 'current-page',
      label: 'Ajout de services'
    }],
    token: getToken()
  };
  requests = {};
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.verifyToken();
  }
  verifyToken = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('verifyBookingToken'), {
      token: state.token,
      type: 'add-services'
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        booking: response.booking,
        cancel_sv_token: response.cancel_sv_token,
        services_by_category: response.services_by_category || {},
        services_categories: response.services_categories,
        every_service_is_booked: response.every_service_is_booked,
        ready: true
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  addServices = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading) return;
    component.setState({
      loading: true
    });
    qwest.post(action('addBookingServices'), {
      token: state.token,
      selected: state.selected || {},
      expected_amount: state.added_amount
    }).then(function (xhr, response) {
      component.setState({
        error: response.error,
        warning: response.warning,
        info: response.info,
        selected: {},
        selected_count: 0,
        added_amount: 0,
        loading: false,
        ready: false
      });
      const payment_page = URL('PayBookingServicesPage').replace(':token', response.token);
      app.navigateTo(payment_page);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  selectService = (value, id) => {
    const component = this,
      props = this.props,
      state = this.state;
    const selected = {
      ...state.selected,
      [id]: value
    };
    const selected_keys = Object.keys(selected).filter(id => num(selected[id], 0) > 0);
    component.setState({
      selected: selected,
      selected_count: selected_keys.length,
      added_amount: selected_keys.length > 0 === false ? 0 : selected_keys.reduce(function (total, id) {
        let service;
        Object.keys(state.services_by_category).find(function (category) {
          service = (state.services_by_category[category] || []).find(service => service.id === id);
          return service ? true : false;
        });
        const service_cost = getTotalServiceAmount({
          service: service,
          quantity: num(selected[id], 0),
          hours_count: state.booking?.hours_count || 0
        });
        return num(total + service_cost);
      }, 0)
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-red']
    }) : undefined;
    const home_btn = /*#__PURE__*/React.createElement(Button, {
      type: "button",
      href: "/",
      className: bemit('c-arrow-btn', ['primary', 'big']) + ' u-margin-top-10'
    }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
      className: "c-arrow-btn__arrow"
    }), /*#__PURE__*/React.createElement("span", {
      className: "c-arrow-btn__text"
    }, "Revenir \xE0 l'accueil de myWO"));
    const validate_btn = state.ready ? /*#__PURE__*/React.createElement("div", {
      className: "add-booking-services-controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      onClick: component.addServices,
      className: bemit('c-flat-btn', ['green', 'v2', 'big']),
      disabled: state.selected_count > 0 === false
    }, loader, "Ajouter et r\xE9gler", state.selected_count === 1 ? ' ce service' : state.selected_count > 1 ? ' ces ' + state.selected_count + ' services' : ' ces services')) : undefined;
    const amount_info = state.added_amount > 0 ? /*#__PURE__*/React.createElement("div", {
      className: bemit('c-message', ['v2', 'blue', 'align-left']) + ' u-margin-top-10'
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Le co\xFBt de", state.selected_count > 1 ? ' ces services ' : ' ce service ', "est de", /*#__PURE__*/React.createElement("strong", null, ' ' + formatNum(state.added_amount, '0,0[.]00'), "\u20AC"), '.')) : undefined;
    const left_content = state.every_service_is_booked ? /*#__PURE__*/React.createElement(React.Fragment, null, home_btn, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-message', ['v2', 'warning', 'info-icon', 'align-left'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Votre r\xE9servation comprend d\xE9j\xE0 tous les services propos\xE9s pour cet espace."))) : /*#__PURE__*/React.createElement(React.Fragment, null, home_btn, state.ready ? /*#__PURE__*/React.createElement("div", {
      className: bemit('c-message', ['v2', 'green', 'icon', 'align-left'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Choisissez les services \xE0 ajouter.")) : undefined, state.ready && state.booking ? /*#__PURE__*/React.createElement(AddBookingServices, {
      start: state.booking.start,
      end: state.booking.end,
      hours_count: state.booking.hours_count,
      prople: state.booking.prople,
      selected: state.selected,
      categories: state.services_categories,
      onChange: component.selectService
    }) : undefined, amount_info, getFormStatus(state, ['v2']), validate_btn, window.innerWidth >= 1200 && state.ready ? home_btn : undefined);
    const page_content = /*#__PURE__*/React.createElement("div", {
      className: "add-booking-services-container"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      links: state.breadcrumb,
      bemit: ['no-padding'],
      className: "u-margin-bottom-10"
    }), state.cancel_sv_token ? /*#__PURE__*/React.createElement("div", {
      className: bemit('c-message', ['v2', 'blue', 'info-icon', 'align-left'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Vous souhaitez annuler certains services\xA0?", ' ', /*#__PURE__*/React.createElement(Link, {
      className: "c-message__link\r c-message__underlined",
      href: URL('CancelBookingServicesPage').replace(':token', state.cancel_sv_token)
    }, /*#__PURE__*/React.createElement("strong", null, "Cliquez ici")))) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "add-booking-services-container__content"
    }, left_content), /*#__PURE__*/React.createElement("div", {
      className: "add-booking-services-container__infos"
    }, /*#__PURE__*/React.createElement(BookingInfosCard, {
      booking: state.booking,
      "discount-code": state.booking?.discount_code
    }), state.every_service_is_booked ? undefined : window.innerWidth < 1200 && state.ready ? home_btn : undefined));
    let output = /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['primary-bg'])
    }), /*#__PURE__*/React.createElement("div", {
      className: "page-container"
    }, page_content));
    return output;
  }
}
